<template>
  <div class="headerSer">
    <!-- <span @click="showToken()">关联码</span>  -->
    <el-popover placement="bottom" width="530" trigger="hover">
      <div class="service">
        <div class="serve">
          <div>
            <img v-if="false" :src="logo" alt="快递帮">
            <div style="width: 80px; margin: 0; text-align: center">客户服务</div>
          </div>
          <div style="margin-top: 10px; height: 90px; display: flex; flex-direction: column; justify-content: space-around">
            <div>工作日 8:00-23:00</div>
            <div>节假日 9:00-23:00</div>
          </div>
        </div>
         <p>
          <span class="span_img">
            <a target="_blank" :href="'http://wpa.qq.com/msgrd?v=3&amp;uin=292992358&amp;site=qq&amp;menu=yes'">
            <svg-icon icon-class="SERQQ" class-name="card-panel-icon" />
          </a>
          </span>
          <span class="span_cont"><a target="_blank" :href="'http://wpa.qq.com/msgrd?v=3&amp;uin=292992358&amp;site=qq&amp;menu=yes'">QQ</a></span>
          <span class="span_a">
            <a target="_blank" :href="'http://wpa.qq.com/msgrd?v=3&amp;uin=292992358&amp;site=qq&amp;menu=yes'">
              <el-button type="text">292992358</el-button>
            </a>
          </span>
        </p>
        <!-- <p>
          <span class="span_img">
            <svg-icon icon-class="serPhone" class-name="card-panel-icon" />
          </span>
          <span class="span_cont">电话</span>
          <span class="span_a">
            <el-button type="text">13456557089</el-button>
          </span>
        </p> 
        <p>
          <span class="span_img">
            <svg-icon icon-class="serPhone" class-name="card-panel-icon" />
          </span> 
          <span class="span_cont">客服微信</span>
          <span class="span_a">
            <el-image style="width: 100px; height: 100px" :src="qrcode" fit="fit" />
          </span>
        </p> -->
      </div>
      <span slot="reference">联系客服</span>
    </el-popover>
  </div>
</template>

<script>
import pdd from '@/assets/head/pdd.jpg'
import logo from '@/assets/head/logo(2).jpg'
import cusQrcode from '@/assets/cusQrcode.png'

export default {
  name: 'HeaderSearch',
  data() {
    return {
      pdd: pdd,
      logo: logo,
      qrcode: cusQrcode,
      mall_token: '',
      mall_name: ''
    }
  },
  computed: {},
  watch: {},
  methods: {
    async showToken() {
      this.mall_token = localStorage.getItem('mall_token')
      this.mall_name = localStorage.getItem('shopName')
      this.$confirm(this.mall_name + '：' + this.mall_token, '店铺关联码', {
        confirmButtonText: '一键复制',
        cancelButtonText: '关闭'
      })
        .then(() => {
          try {
            navigator.clipboard.writeText(this.mall_token)
            console.log('内容已复制到剪贴板')
            this.$message({
              type: 'success',
              message: '复制成功!'
            })
          } catch (err) {
            console.error('复制到剪贴板失败:', err)
            this.$message({
              type: 'error',
              message: err
            })
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.headerSer {
  display: flex;
  height: 50px;
  align-items: center;
  span {
    cursor: pointer;
    &:nth-child(1) {
      margin-right: 10px;
    }
    &:nth-child(2) {
      margin-right: 5px;
    }
  }
}

.service {
  padding: 10px 20px;
  .serve {
    display: flex;
    align-items: center;
    font-size: 18px;
    img {
      width: 70px;
    }
    div {
      margin-left: 15px;
    }
  }
  p {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    .span_img {
      display: inline-block;
      width: 5%;
      img {
        width: 30px;
        height: 30px;
        border-radius: 6px;
      }
      .card-panel-icon {
        font-size: 35px;
      }
    }
    .span_cont {
      display: inline-block;
      padding-left: 20px;
      width: 26%;
      text-align: left;
      font-size: 18px;
    }
    .span_a {
      display: inline-block;
      align-items: left;
      // width: 25%;
      span {
        display: inline-block;
        width: 45px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background-color: #ff4949;
        font-weight: 600;
        color: #fff;
        border-radius: 3px;
      }
      button {
        font-size: 18px;
        align-items: left;
      }
    }
  }
}
</style>
